import type { PublicSlotKey } from '#packages/apilib';
import type { AiWriterApi } from './aiWriterAPI';

export const AiWriterApiKey: PublicSlotKey<AiWriterApi> = {
  name: 'AiWriterApi',
  public: true,
};
